import image from "./Images/Screenshot 2023-09-29 133033.jpg";
import newsFlash from "./Images/Screenshot 2023-09-29 133001.jpg";
import sushiFood from "./Images/Screenshot 2023-09-29 133918.jpg";
import loopStudio from "./Images/Screenshot 2023-09-29 134101.jpg";
import padiAgent from "./Images/Screenshot 2023-09-29 132836.jpg";
import onCredit from "./Images/Screenshot 2023-09-29 132612.jpg";
import allPrint from "./Images/Screenshot 2023-09-29 132427.jpg";
import valaPrime from "./Images/Screenshot 2023-09-29 134007.jpg";
import bibleQuote from "./Images/Screenshot 2023-09-29 134257.jpg";

const details = [
  {
    id: 0,
    icon: image,
    title: "Fitness Club",
    text:
      "The Fitness-Club is a comprehensive web application designed to help individuals achieve their fitness goals and maintain a healthy lifestyle.",
    sourceCode: "https://github.com/therealtmmy/Fitness-Club",
    link: "https://fitness-club-rose.vercel.app/",
  },

  {
    id: 1,
    icon: newsFlash,
    title: "NewsFlash",
    text:
      "Discover a captivating blog featuring articles, news, and insights. Engage with content, comment, and share. Stay informed with regular updates.",
    sourceCode: "https://github.com/therealtmmy/News-Flash",
    link: "https://ost-blog.vercel.app/index.html",
  },

  {
    id: 2,
    icon: sushiFood,
    title: "SushiApp",
    text:
      "The Sushi-Food-App is a web application that provides a seamless and enjoyable experience for sushi lovers. With an extensive menu of sushi dishes.",
    sourceCode: "https://github.com/therealtmmy/Sushi-Food-App",
    link: "https://fetch-api-4g6l-git-main-eoluwatimilehin.vercel.app/",
  },

  {
    id: 3,
    icon: loopStudio,
    title: "Loop Studio",
    text:
      "lorem every la prime this is the real of the things that we are tryng to cook and this looks great in my sight and we are still working on it",
    sourceCode: "https://github.com/therealtmmy/Loop-Studio",
    link: "https://loop-studio-landing-wine.vercel.app/",
  },

  {
    id: 4,
    icon: padiAgent,
    title: "PadiAgent",
    text:
      "The padiAgent is a comprehensive real estate management solution for agents. It provides features such as property management, agents.",
    sourceCode: "https://github.com/therealtmmy/Padi-Agent",
    link: "https://fetch-api-4g6l-git-main-eoluwatimilehin.vercel.app/",
  },
  {
    id: 5,
    icon: onCredit,
    title: "onCredit",
    text:
      "The OnCredit is a project that demonstrates the usage of the Fetch API, a modern JavaScript API for making network requests.",
    sourceCode: "https://github.com/therealtmmy/OnCredit",
    link: "https://on-credit-zeta.vercel.app/",
  },

  {
    id: 6,
    icon: allPrint,
    title: "All Season Printing",
    text:
      "lorem every la prime this is the real of the things that we are tryng to cook and this looks great in my sight and we are still working on it",
    sourceCode: "https://github.com/therealtmmy/ASPC",
    link: "https://allseasonsprintingcompany.vercel.app/",
  },

  {
    id: 7,
    icon: valaPrime,
    title: "Vacation La Prime",
    text:
      "lorem every la prime this is the real of the things that we are tryng to cook and this looks great in my sight and we are still working on it",
    sourceCode: "https://github.com/therealtmmy/Vacation-La-Prime",
    link: "https://valaprime.netlify.app/",
  },

  {
    id: 8,
    icon: bibleQuote,
    title: "Bible Quote Generator",
    text:
      "The Random Bible Quote Generator is a simple web application that allows users to generate random Bible quotes at the click of a button.",
    sourceCode: "https://github.com/therealtmmy/Bible-Quote-Generator",
    link: "https://bible-verse-generator.vercel.app/",
  },
];

export default details;
